import { observer } from 'mobx-react-lite'

import { EntityHeader } from '@/Ship/Components/EntityCard'

import type { OtherCarrierFormContextLike } from '../Contracts/IOtherCarrier'

/**
 * Шапка картки іншого перевізника (`SPEC-010` §9.7): назва, під нею — ЄДРПОУ.
 *
 * Окремим observer-компонентом: шапка читає поля, які редагують, а шаблон
 * картки цього робити не може — ядровий `FormField` перемонтовував би всі поля
 * на кожну літеру (`SPEC-002` §4.2).
 */
export const OtherCarrierCardHeader = observer(({ formContext }: { formContext: OtherCarrierFormContextLike }) => {
    const values = formContext.values ?? {}
    const title = typeof values.title === 'string' ? values.title.trim() : ''
    const edrpou = typeof values.edrpou === 'string' ? values.edrpou.trim() : ''

    return (
        <EntityHeader
            {...(title !== '' ? { title } : {})}
            {...(edrpou !== '' ? { subtitle: `Код ЄДРПОУ ${edrpou}` } : {})}
        />
    )
})
